import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=2e1d7cd1&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.scss?vue&type=style&index=0&id=2e1d7cd1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d7cd1",
  null
  
)

export default component.exports